import { combineReducers } from '@reduxjs/toolkit';
import sidebarReducer from './ui';
import globalLoaderReducer from './ui/loader';
import languageReducer from './language';

const commonReducer = combineReducers({
  sidebar: sidebarReducer,
  language: languageReducer,
  globalLoader: globalLoaderReducer,
});

export type CommonState = ReturnType<typeof commonReducer>;

export default commonReducer;
